// extracted by mini-css-extract-plugin
module.exports = {"layout":"CaseLayout_layout__1vfWs","messages":"CaseLayout_messages__3C7Ao","details":"CaseLayout_details__2V3I1","overlay":"CaseLayout_overlay__1EAiq"};